import { Box } from "@mui/material";
import React from "react";
import {
  allowedToDeleteEntity,
  allowedToUpdateEntity,
} from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { ttsContextColumns as columns } from "../../Helper";
import { isOpenPopup } from "src/utils/isOpenPopup";
import { Link } from "react-router-dom";
import { path } from "src/constants/path";
import Controls from "src/components/form/controls/Controls";
import { TTSContextType } from "src/pages/TTS/constants";

const isEmptyContext = (context) =>
  context.type.toLowerCase() === TTSContextType.SUCCESS_EMPTY;

const GetTTSContextColumns = ({ handleDelete, handleOpenPopup, status }) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const configCol = {
    key: "configSlot",
    label: "Config Slot",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) &&
          (!isEmptyContext(item) ? (
            <Link
              to={{
                pathname: `${path.ttsContext}/slot/${item.id}`,
              }}
            >
              <Controls.Button
                text="Config Slot"
                variant="outlined"
                color="warning"
              />
            </Link>
          ) : (
            <Controls.Button
              text="Config Slot"
              variant="outlined"
              color="warning"
              disabled={isEmptyContext(item)}
            />
          ))}
      </Box>
    ),
  };

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-warning"
            // className={`btn btn-warning ${
            //   isEmptyContext(item) ? "not-allowed" : ""
            // }`}
            onClick={() => {
              handleOpenPopup(isOpenPopup, item);
            }}
            // disabled={isEmptyContext(item)}
          >
            <i className="bx bx-edit"></i>
          </button>
        )}
        {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-danger"
            // className={`btn btn-danger ${
            //   isEmptyContext(item) ? "not-allowed" : ""
            // }`}
            onClick={() => handleDelete(item)}
            // disabled={isEmptyContext(item)}
          >
            <i className="bx bx-trash"></i>
          </button>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, configCol, actionCol];
  }

  return columns;
};

export default GetTTSContextColumns;
